var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanySize210(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.746,
    height: 36.587,
    viewBox: "0 0 73.746 36.587",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_size_2-10_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2629",
    "data-name": "Rectangle 2629",
    width: 73.746,
    height: 36.587,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3332",
    "data-name": "Group 3332",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(0 0)",
    clipPath: "url(#company_size_2-10_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M558.552,49.76a7.46,7.46,0,0,0-14.919.01c0,.179.007.36.021.542a8.784,8.784,0,1,0,10.332,13.542,7.455,7.455,0,1,0,4.567-14.094m-1.494,12.768a5.446,5.446,0,0,1-2.854-.812,1,1,0,0,0-1.363.313,6.789,6.789,0,1,1-7.793-10.111,1,1,0,0,0,.676-1.133,5.47,5.47,0,1,1,10.781-.294,1,1,0,0,0,.922,1.125,5.463,5.463,0,0,1-.368,10.913",
    transform: "translate(-493.623 -38.797)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M697.23,164.312a1,1,0,0,0-1,1v20.43a1,1,0,0,0,1.993,0v-20.43a1,1,0,0,0-1-1",
    transform: "translate(-638.412 -150.666)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M706.732,212.221l-2.486,2.486a1,1,0,1,0,1.409,1.409l2.486-2.486a1,1,0,1,0-1.409-1.409",
    transform: "translate(-645.492 -194.329)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M649.783,170.315a1,1,0,0,0-1.409,1.409l3.977,3.977a1,1,0,1,0,1.409-1.409Z",
    transform: "translate(-594.26 -155.903)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M298.618,292.568a3.591,3.591,0,0,1-1.979-1.5v10.421H272.616v1.993h25.02a1,1,0,0,0,1-1v-9.918l-.014,0",
    transform: "translate(-249.976 -266.899)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M425.471,0h-6.249a1,1,0,0,0-1,1V7.6a1,1,0,0,0,1,1h6.249a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1m-1,6.6h-4.256V1.993h4.256Z",
    transform: "translate(-383.492)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M177.189,287.675a4.39,4.39,0,0,0-4.385,4.385v6.706a1,1,0,0,0,1,1h6.776a1,1,0,0,0,1-1V292.06a4.39,4.39,0,0,0-4.385-4.385m2.391,10.094H174.8V292.06a2.392,2.392,0,1,1,4.783,0Z",
    transform: "translate(-158.453 -263.784)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M116.462,236.361v14.917H99.924V236.309c-.725,0-1.4,0-1.993.008v15.958a1,1,0,0,0,1,1h18.531a1,1,0,0,0,1-1V236.391l-1.993-.03",
    transform: "translate(-89.798 -216.684)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M205.518,50.686l1.674,1.956h15.661V50.649H205.068a1,1,0,0,0-1,1v.732Z",
    transform: "translate(-187.123 -46.443)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M504.476,71.24a3.229,3.229,0,0,1,.439-.221L498.252,62.4v2.413H497.6l5.745,7.43a4.239,4.239,0,0,1,1.133-1",
    transform: "translate(-456.274 -57.22)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M367.146,202.382c.1-.171.211-.337.321-.5h-16.95l1.705,1.993H366.7a3.179,3.179,0,0,1,.448-1.49",
    transform: "translate(-321.407 -185.113)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M58.71,252.138l.014-.018-.02.024.006-.007",
    transform: "translate(-53.829 -231.182)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M53.556,23.961a1.031,1.031,0,0,0-1.54,0L37.756,41.316a1,1,0,0,0,.41,1.6,1,1,0,0,0,.581.028c1.486-.125,17.651-.051,28.314.031h.008a1,1,0,0,0,.77-1.629ZM39.273,42.61l-.006.006a1.021,1.021,0,0,1-.085.09h0a.951.951,0,0,1-.329.2,1,1,0,0,0,.329-.2h0a1,1,0,0,0,.085-.09l.02-.024Zm13.6-1.711c-3.67-.014-6.421-.024-8.49-.024-1.609,0-2.805.006-3.7.02l12.1-14.732,12.163,14.8c-2.633-.018-7.349-.048-12.077-.066",
    transform: "translate(-34.391 -21.654)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M57.679,253.5h0",
    transform: "translate(-52.888 -232.446)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M395.636,269.552h-8.993a1,1,0,0,0-1,1v7.718a1,1,0,0,0,1,1h8.993a1,1,0,0,0,1-1v-7.718a1,1,0,0,0-1-1m-1,7.718h-7v-5.724h7Z",
    transform: "translate(-353.62 -247.166)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M441.23,271.527a1,1,0,0,0-1,1v7.39a1,1,0,1,0,1.993,0v-7.39a1,1,0,0,0-1-1",
    transform: "translate(-403.673 -248.977)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M72.75,416.1H1a1,1,0,1,0,0,1.993H72.75a1,1,0,1,0,0-1.993",
    transform: "translate(0 -381.539)",
    fill: "currentColor"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySize210);
export default __webpack_public_path__ + "static/media/company_size_2-10.9a98afca.svg";
export { ForwardRef as ReactComponent };